// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-belmont -> aion-management-belmont -> the-ridge
// Generated: 2026-10-22T20:04:38.723Z
// Counts: 1 design, 68 content, 63 slot group, 1 collection binding, 9 section, 9 style

export const designOverrides = {
  "design._site.color.linkUnderline": {
    "cssVariable": "--vibe-color-link-underline",
    "overrideType": "VALUE",
    "value": "underline",
    "mappedField": null
  }
};

export const contentOverrides = {
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.pretitle": {
    "overrideType": "VALUE",
    "customValue": "<p>1, 2, & 3 BEDROOM LAYOUTS</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>1, 2, & 3 Bedroom Apartments for Rent in Hagerstown , MD</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>The Ridge Apartments</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodshowcase.description": {
    "overrideType": "VALUE",
    "customValue": "<p>At The Ridge Apartments in Hagerstown, MD, enjoy a vibrant community with diverse floor plans, from cozy one-bedroom to spacious three-bedroom apartments. Embrace convenient access to local treasures like the Washington County Museum of Fine Arts, Hagerstown Community College, and scenic parks. Dive into your new lifestyle today!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pinnedcallouts.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>tour anytime. from anywhere.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pinnedcallouts.title": {
    "overrideType": "VALUE",
    "customValue": "<p>We're Here For You</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.pre_title": {
    "overrideType": "VALUE",
    "customValue": "<p>your new home awaits</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Embrace the Joy of Living in Your Perfect Home</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "_head.favicon_url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_fav_icon"
  },
  "accessibility-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "accessibility-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Accessibility Statement</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The amenities at The Ridge provide a living experience that elevates every day and makes you glad to come home. From fully equipped kitchens and large walk-in closets to the community grilling pavilion, dog park, and resort-style swimming pool, The Ridge is the perfect place to call home. Here are more amenities we know you’ll love.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Amenities</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentHeading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Features</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentOverline": {
    "overrideType": "VALUE",
    "customValue": "<h3>Interior</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityHeading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Amenities</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityOverline": {
    "overrideType": "VALUE",
    "customValue": "<h3>Community</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.select_units_disclaimer": {
    "overrideType": "VALUE",
    "customValue": "*In Select Homes",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Apply Now</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Contact Us</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Floor Plans</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Spaciously Designed Apartments For Rent</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Gallery</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/patio-balcony-apartments-fullerton-pa::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Discover ideal apartments with patio or balcony in Fullerton, PA. Enjoy serene outdoor spaces with modern amenities at Fairmont Place.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/patio-balcony-apartments-fullerton-pa::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apartments with Patios &amp; Balconies in Fullerton, PA</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore the community layout</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Interactive Map</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Neighborhood</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Pet-friendly living guidelines</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.restrictions_heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Pet Restrictions</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.welcome_text": {
    "overrideType": "VALUE",
    "customValue": "<h3>Dogs &amp; Cats Welcome</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Privacy Policy</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Resident Portal</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "residentaccess.app_heading": {
    "overrideType": "VALUE",
    "customValue": "<p>Download the Loft Resident Mobile App</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>What residents are saying</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Reviews</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Schedule a Tour</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduletourform.form_block": {
    "overrideType": "VALUE",
    "customValue": "elise-schedule-tour-iframe",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Sitemap</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Thank You</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Virtual Tours</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At The Ridge Apartments in Hagerstown, MD, choose from spacious one, two, or three-bedroom floor plans designed for your lifestyle. Delight in a range of amenities, from a refreshing pool and modern fitness center to serene walking trails and a vibrant dog park. Lease online today and elevate your living experience!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At The Ridge Apartments in Hagerstown, MD, we offer spacious <a href=\"https://www.theridgehagerstown.com/floor-plans/\">one, two, and three-bedroom</a> floor plans designed for your lifestyle. Each layout combines comfort and style, perfect for making lifelong memories. Have questions? Reach out to our leasing team today and find your ideal home!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our charming Hagerstown community with upgraded floor plans is located in a tranquil garden-like setting. From beautifully landscaped surroundings to high-end in-home perks, everything you need to feel comfortable at home is right here.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Picture yourself here. Our photo gallery is here to help you imagine your new everyday routine at The Ridge. Check out snapshots of our pet-friendly community, comfortable apartments, and our plentiful community amenity offerings. Flex your muscles at the on-site fitness center. Soak away the stresses of the day with a few laps in our resort-worthy swimming pool. It’s all waiting for you! Contact our friendly leasing staff today and discover more reasons why our residents love living here.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Conveniently situated near shopping centers, top employers, and a host of recreation spots, The Ridge boasts a location that is perfect for any suburban dweller who values peace and quiet. Our upgraded apartment homes are nestled in a tranquil setting near Marty Snook Park that provides the haven you desire while giving you access to the urban conveniences that make daily living effortless.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodshowcase.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Stylish Apartment Living in Hagerstown , MD</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicycallout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>We’re a pet‑friendly community and we’re happy to welcome your cats and dogs. Breed restrictions apply; please contact the leasing office for details. You can have up to 2 pets per apartment, with each pet up to 100 lb. There is a one‑time, non‑refundable pet fee of $300 and monthly pet rent is $50.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.description": {
    "overrideType": "VALUE",
    "customValue": "<p>The Ridge offers thoughtfully designed and upgraded one, two, and three bedroom apartments near Interstate 81 and 70 in Hagerstown, Maryland, with the amenities and extras that make your life comfortable and worry-free. Enjoy an outdoor picnic area, a resort-style swimming pool, and a newly upgraded kitchen and expansive walk-in closets. Our luxe community is conveniently located near popular dining, outdoor recreation, and shopping, so your next-level living experience extends beyond your front door.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to The Ridge Apartments in Hagerstown, MD, where comfort meets convenience. Our diverse floor plans range from one to three bedrooms, tailored to fit your lifestyle. Access your resident portal to effortlessly pay rent, schedule maintenance, and embrace a seamless living experience today!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At The Ridge Apartments in Hagerstown, MD, choose from our thoughtfully designed one, two, and three-bedroom floor plans that cater to your lifestyle. Experience modern living with community vibes. Schedule a tour today and find out why residents love calling The Ridge home! Check out their testimonials!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Thank you for reaching out to The Ridge Apartments in Hagerstown, MD! Our diverse floor plans, from cozy one-bedroom hideaways to spacious three-bedroom homes, are tailored to fit your lifestyle. A member of our friendly team will connect with you shortly to help you find your perfect space!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Experience The Ridge Apartments in Hagerstown, MD, where stylish floor plans meet modern living. Choose from <a href=\"https://www.theridgehagerstown.com/floor-plans/\">one, two, or three-bedroom</a> options tailored for your lifestyle. Ready to see your future home? Take a virtual tour and immerse yourself in our vibrant community today!</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contact-hero.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "View Floor Plans"
      }
    }
  },
  "pinnedcallouts.cta2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/contact-us"
      }
    }
  },
  "propertyoverview.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "View Availability & Pricing"
      }
    }
  },
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "header.apply_now_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/apply-now"
      }
    }
  },
  "amenitieslist.in_home_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-4304-71aa-9089-90b91d09392e.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern apartment bedroom with a bed, dresser, wall-mounted TV, and large potted plant at The Ridge Apartments in Hagerstown, MD"
      }
    }
  },
  "amenitieslist.indoor_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-77cd-7612-9835-ac515f1dfd5f.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Indoor fitness center with dumbbells, benches, and a cable machine near windows at The Ridge Apartments in Hagerstown, MD"
      }
    }
  },
  "amenitieslist.indoorPhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026f-41fc-711c-ae95-f9bb438242a7.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Interior view of a modern residential gym with free weights, benches, and weight rack."
      }
    }
  },
  "amenitieslist.indoorPhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026d-2c8f-7651-9101-4c760ca9d7ef.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Indoor apartment gym with treadmills and elliptical machines by large windows."
      }
    }
  },
  "amenitieslist.indoorPhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166356/019d026f-41fc-711c-ae95-f9bb438242a7.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Gym equipment including dumbbells, weight benches, and a cable machine in a well-lit room."
      }
    }
  },
  "amenitieslist.inHomePhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026f-25e5-76bf-82d4-ee100e277457.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bright galley kitchen with white cabinets, granite countertops, stainless sink, and small plant decor."
      }
    }
  },
  "amenitieslist.inHomePhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026c-be33-778e-9d4a-6e0a3bef1fe5.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room with beige sofa, round coffee table, TV on a white console, and a sliding glass door."
      }
    }
  },
  "amenitieslist.inHomePhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026c-cf99-750f-86d6-07ad9397d675.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bedroom in an apartment with a large bed, dresser, wall-mounted TV, and doors to the bathroom and closet."
      }
    }
  },
  "amenitieslist.neighborhood_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-8714-75ea-a8de-d9521f4c6b96.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior view of a two-story brick apartment building with a central glass entry and landscaped shrubs at The Ridge Apartments in Hagerstown, MD"
      }
    }
  },
  "amenitieslist.neighborhoodPhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026d-5e3d-7461-b083-fa0c7e4ab937.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Hagerstown Premium Outlets, an open-air outlet mall with brand-name factory stores near The Ridge."
      }
    }
  },
  "amenitieslist.neighborhoodPhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026d-5e5a-725b-8339-1d9cb7d3f765.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Valley Mall in Hagerstown, with department stores, shops, and a movie theater a short drive away."
      }
    }
  },
  "amenitieslist.neighborhoodPhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026d-7d38-70ad-a521-8ea813f8abed.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Antietam National Battlefield, a nearby Civil War historic site with scenic driving tours and trails."
      }
    }
  },
  "amenitieslist.outdoor_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-5630-75ba-aca2-76ea50f1f0e1.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Outdoor community pool area with lounge chairs, orange umbrellas, and greenery at The Ridge Apartments in Hagerstown, MD"
      }
    }
  },
  "amenitieslist.outdoorPhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026f-41a8-721e-94c1-debda0574c7f.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor circular pool with black fence, seating, and an orange umbrella."
      }
    }
  },
  "amenitieslist.outdoorPhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026d-2c64-70ca-b684-f92c49304ad7.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Playground equipment on a sandy surface with grass and trees around"
      }
    }
  },
  "amenitieslist.outdoorPhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026c-f631-7619-aed8-e5035edaa6cc.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor community grill area with a wooden pavilion and picnic tables on a concrete pad."
      }
    }
  },
  "feesheet.admin": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Admin Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": ""
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.amenity": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Amenity Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$100"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.application": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Application Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$25"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.buyout": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Buy-Out Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "1 Month's Rent"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.custom_situational": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Admin Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "50"
      },
      "cost_detail": {
        "type": "VALUE",
        "customValue": "Assessed per occurrence for any modification to the Lease Agreement, including but not limited to the addition, removal, or substitution of any leaseholder or occupant."
      }
    }
  },
  "feesheet.electric": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility — Electric"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "Usage-Based (Utilities)"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.gas": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility — Gas"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "Usage-Based (Utilities)"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.late": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Late Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "5%"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.lockout": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Lockout Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$25"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.nsf": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "NSF Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$50"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.parking_reserved": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Reserved Parking Space"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$25"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.pet_fee": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Pet Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$300"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.pet_rent": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Pet Rent"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$50"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      },
      "cost_detail": {
        "type": "VALUE",
        "customValue": "Per pet. Max 2."
      }
    }
  },
  "feesheet.reservation": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Reservation Deposit"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$200"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.security": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Security Deposit"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$750*"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      },
      "cost_detail": {
        "type": "VALUE",
        "customValue": "Deposit amount applies with approved credit and may be higher for conditional approvals"
      }
    }
  },
  "feesheet.transfer": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Transfer Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$500"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.trash": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Trash Service"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$10"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.utility_admin": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility Admin / Billing"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$4.66"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.utility_setup": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility New Account"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$10"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.water": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility — Water & Sewer"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "Usage-Based (Utilities)"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "floorplanslist.card_image_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce70-e5fe-713b-a2d8-73d7d3dba626.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "View All"
      }
    }
  },
  "floorplanslist.card_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026c-be33-778e-9d4a-6e0a3bef1fe5.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Compact living room with a beige sofa, round coffee table, TV on a white console, and a sliding glass door."
      }
    }
  },
  "floorplanslist.card_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce70-e6c5-71f0-a3c1-ed6a7501ab7d.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "One Bedroom"
      }
    }
  },
  "floorplanslist.card_image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce70-e727-7795-a5f1-a381ca0eac0a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Two Bedroom"
      }
    }
  },
  "floorplanslist.card_image_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce70-ea1b-7798-9fb2-fdc81ca10c9f.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Three Bedroom"
      }
    }
  },
  "neighborhoodhighlights.day_poi_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-d5a4-710a-b688-142dfa07a519.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "River Bottom Roasters"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Coffee & Cafe"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "3.1 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Coffee roaster offering a variety of specialty espresso drinks (fair-trade, oatmilk)."
      }
    }
  },
  "neighborhoodhighlights.day_poi_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-db6e-770d-bd32-4fa094be8db9.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Hagerstown Premium Outlets"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Shopping"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "3.4 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Village-feel outlet mall, eatery-equipped, outdoor-focused shopping venue featuring factory stores for name-brand apparel, accessories and home goods."
      }
    }
  },
  "neighborhoodhighlights.day_poi_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce12-0eab-750f-a89b-681550cf5d91.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Fairgrounds Park"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Parks & Recreation"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "2.8 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Urban park with a grandstand, playground & dog area, plus indoor & outdoor sports facilities."
      }
    }
  },
  "neighborhoodhighlights.day_poi_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-c180-7344-aa01-4fdeba677cf8.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Hub City Diner"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Breakfast & Brunch"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "2.7 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Relaxed option serving American favorites, including omelets, pancakes, French toast and grits."
      }
    }
  },
  "neighborhoodhighlights.day_poi_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-f4ad-748b-8953-ff47294dba89.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Washington County Museum of Fine Arts"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Arts & Culture"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "3.0 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Changing exhibits of 7,000+ paintings & sculptures by global artists of the 18th-20th centuries."
      }
    }
  },
  "neighborhoodhighlights.day_poi_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce12-1613-725f-9df3-903fbb39a965.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "C&O Canal National Historical Park"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Trails & Recreation"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "4.0 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Canal trail stretching 184 miles from DC to Cumberland and beyond, open to bikers and hikers."
      }
    }
  },
  "neighborhoodhighlights.night_poi_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-cee8-7740-8baf-ee8d11654e52.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Baile Cask & Kettle"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Bar & Pub"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "3.2 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "American and Irish pub with a cozy vibe, serving brews, bagels and burgers."
      }
    }
  },
  "neighborhoodhighlights.night_poi_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-f490-71ab-bfc3-c0c1681b7a49.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "The Maryland Theatre"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Live Entertainment"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "3.3 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Built in 1915, this stately theater with balcony & box seats showcases a variety of performances."
      }
    }
  },
  "neighborhoodhighlights.night_poi_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-c272-73d3-b484-f07d56e72545.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Black Rock Bar & Grill"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Steakhouse"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "2.6 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Steakhouse where diners enjoy steaks served with sides plus seafood and burgers."
      }
    }
  },
  "neighborhoodhighlights.night_poi_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-d531-718c-9a8f-95efa3bd2353.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Antietam Brewery"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Brewery & Lounge"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "3.0 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Local brewery pouring craft beers in a laid-back taproom — an easy spot to unwind after dark."
      }
    }
  },
  "neighborhoodhighlights.night_poi_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-f25e-7202-8267-360a2164ca60.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Warehouse Cinemas Leitersburg"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Cinema"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "4.5 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "10-screen cinema offering 4 VIP theaters with leather reclining seats."
      }
    }
  },
  "neighborhoodhighlights.night_poi_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-c1e1-7469-8f06-c8cd1a8c5d14.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "The Meadows Original Frozen Custard"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Dessert"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "1.6 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Old-fashioned chain established in 1950 specializing in frozen custard cones, sundaes & shakes."
      }
    }
  },
  "neighborhoodshowcase.photo1": {
    "sourceIndex": 23,
    "fieldOverrides": null
  },
  "neighborhoodshowcase.photo2": {
    "sourceIndex": 28,
    "fieldOverrides": null
  },
  "neighborhoodshowcase.photo3": {
    "sourceIndex": 36,
    "fieldOverrides": null
  },
  "neighborhoodshowcase.photo4": {
    "sourceIndex": 34,
    "fieldOverrides": null
  },
  "pinnedcallouts.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-5712-7228-8575-c1ed21adfe8c.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Outdoor pool area with orange umbrellas and black lounge chairs on a concrete deck at The Ridge Apartments in Hagerstown, MD"
      }
    }
  }
};

export const collectionBindingOverrides = {
  "propertyoverview.images": {
    "limit": 3,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "elise-chatbot",
      "blockId": "elise-chatbot",
      "position": 0
    },
    {
      "sectionId": "perq-floor-plan",
      "blockId": "perq-floor-plan",
      "position": 0
    }
  ],
  "accessibility": [
    {
      "sectionId": "audioeye-accessibility",
      "blockId": "audioeye-accessibility",
      "position": 9
    }
  ],
  "apply-now": [
    {
      "sectionId": "realpage-oll",
      "blockId": "realpage-oll",
      "position": 9
    }
  ]
};

export const styleOverrides = {
  "_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "_template:hyperlocal::_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "featuring/air-conditioned-apartments-newport-news-city-harborstone-444::_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "featuring/dog-park-apartments-newport-news-va-harborstone-222::_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "featuring/extra-storage-apartments-fullerton-pa-469::_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "featuring/fitness-center-apartments-23601-harborstone-366::_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "featuring/pet-friendly-apartments-south-newport-news-harborstone-651::_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "_section.InteractiveMapSection": {
    "properties": {
      "paddingTop": "50px",
      "paddingBottom": "50px",
      "backgroundColor": "#ffffff"
    }
  },
  "apartmentsyncsection.block": {
    "properties": {
      "paddingTop": "50px",
      "paddingBottom": "50px"
    }
  }
};
